import InputField from "@components/common/InputField";
import { Email, Phone, AccountCircle } from "@mui/icons-material";
import { Controller } from "react-hook-form";
import type { ProfileFormFieldsProps } from "../types";

const ProfileFormFields: React.FC<ProfileFormFieldsProps> = ({ control, t }) => {
	return (
		<>
			<div className="grid grid-cols-2 gap-4">
				<Controller
					name="firstName"
					control={control}
					render={({ field, fieldState }) => (
						<InputField
							id="profile-firstName"
							placeholder={t("psdaCommon.profile.form.firstName.placeholder")}
							type="text"
							startIcon={<AccountCircle className="mr-2" />}
							error={!!fieldState.error}
							helperText={fieldState.error?.message}
							{...field}
							value={field.value || ""}
						/>
					)}
				/>
				<Controller
					name="lastName"
					control={control}
					render={({ field, fieldState }) => (
						<InputField
							id="profile-lastName"
							placeholder={t("psdaCommon.profile.form.lastName.placeholder")}
							type="text"
							startIcon={<AccountCircle className="mr-2" />}
							error={!!fieldState.error}
							helperText={fieldState.error?.message}
							{...field}
							value={field.value || ""}
						/>
					)}
				/>
			</div>

			<Controller
				name="phoneNumber"
				control={control}
				render={({ field, fieldState }) => (
					<InputField
						id="profile-phoneNumber"
						placeholder={t("psdaCommon.profile.form.phone.placeholder")}
						type="tel"
						startIcon={<Phone className="mr-2" />}
						error={!!fieldState.error}
						helperText={fieldState.error?.message}
						{...field}
						value={field.value || ""}
					/>
				)}
			/>

			<Controller
				name="emailAddress"
				control={control}
				render={({ field, fieldState }) => (
					<InputField
						id="profile-emailAddress"
						placeholder={t("psdaCommon.profile.form.email.placeholder")}
						type="text"
						startIcon={<Email className="mr-2" />}
						error={!!fieldState.error}
						helperText={fieldState.error?.message}
						{...field}
						value={field.value || ""}
					/>
				)}
			/>
		</>
	);
};

export default ProfileFormFields;
